import { SetStateAction } from 'react';

import { EmployeeIdentificationType } from '@fora-monorepo/employer-my-pages-common/types';
import { Flex, RadioButton } from '@foradevelopment/fora-ui';

import { useTypedTranslation } from '../../i18n/i18n';

export const IdentificationTypeForm = ({
  disabled,
  employmentIDType,
  setIDType,
}: {
  disabled: boolean;
  employmentIDType: EmployeeIdentificationType;
  setIDType: React.Dispatch<SetStateAction<EmployeeIdentificationType>>;
}) => {
  const { t } = useTypedTranslation();
  return (
    <Flex flexDirection="column" rowGap={10} role="radiogroup">
      <RadioButton
        id="PersonalIdentityNumber"
        value={employmentIDType}
        checked={employmentIDType === EmployeeIdentificationType.PersonalIdentityNumber}
        name="FormType"
        onChange={() => setIDType(EmployeeIdentificationType.PersonalIdentityNumber)}
        label={t('form.addEmployee.swedishPersonalIdentityNumberLabel')}
        disabled={disabled}
      />
      <RadioButton
        id="CoOrdinationNumber"
        value={employmentIDType}
        checked={employmentIDType === EmployeeIdentificationType.CoOrdinationNumber}
        name="FormType"
        onChange={() => setIDType(EmployeeIdentificationType.CoOrdinationNumber)}
        label={t('common.coordinationNumber')}
        disabled={disabled}
      />
    </Flex>
  );
};
